import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-list" }, null, -1)
const _hoisted_2 = [
  _hoisted_1
]

import ToolBoxContainer from '../../../blockly/ToolBoxContainer';
import {  toolBoxInstance } from '../../../blockly/toolbox_v2';
import { onMounted, ref } from 'vue';



export default /*#__PURE__*/_defineComponent({
  __name: 'ToolboxButton',
  setup(__props) {

const showToolbox = () => {
  const visible = toolBoxInstance.isVisible()
  toolBoxInstance.setVisible(!visible)
};

const isVisible = ref(false);
const responseiveShow = ()=>{
  if (window.innerWidth < ToolBoxContainer.autoHideSizeLimit) {
    isVisible.value = true
  }else{
    isVisible.value = false
  }
}

window.addEventListener("resize",()=>{
  responseiveShow()
})
onMounted(() => {
  responseiveShow()
});


return (_ctx: any,_cache: any) => {
  return (isVisible.value)
    ? (_openBlock(), _createElementBlock("button", {
        key: 0,
        class: "btn btn-danger btn-lg me-2",
        onClick: showToolbox
      }, _hoisted_2))
    : _createCommentVNode("", true)
}
}

})